<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-buttons
                [grid]="grid"
                [canEdit]="canEdit"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <action-toolbar-search name="batterySearch" [(ngModel)]="grid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid id="mainGrid" #mainGrid appAutoSize (initialized)="grid.initialize(mainGrid)" (destroy)="grid.destroy()" [itemsSource]="grid.view">
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="'*'" [dataMap]="equipmentDataMap">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    <a [routerLink]="['/equipment/parts-fluids-lookup']" [queryParams]="{ tab: 'equipment', equipment: cell.item.equipment }">{{
                        parent.equipmentDisplay(cell.item.equipment)
                    }}</a>
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Battery Size/Group'" [binding]="'batterySizeGroup'" [width]="'*'">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    @if (cell.item.batterySizeGroup) {
                        <a [routerLink]="['/equipment/parts-fluids-lookup']" [queryParams]="{ tab: 'item', item: cell.item.batterySizeGroup }">{{
                            cell.item.batterySizeGroup
                        }}</a>
                    }
                </ng-template>
            </wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
